import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompose';

import {
  clearAssets,
  loadAssets,
  loadAsset,
  setCurrentAsset,
} from 'redux/assets/actions';
import {
  assetsSelector,
  currentAssetSelector,
} from 'redux/assets/selectors';

import immutableToJS from 'utils/immutableToJS';

/* istanbul ignore next */
const withConnectedData = (WrappedComponent) => {
  function Container(props) {
    return (
      <WrappedComponent {...props} />
    );
  }

  Container.propTypes = {
    assets: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
      }),
    ).isRequired,
    currentAsset: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
    clearAssets: PropTypes.func.isRequired,
    loadAssets: PropTypes.func.isRequired,
    loadAsset: PropTypes.func.isRequired,
    setCurrentAsset: PropTypes.func.isRequired,
  };

  function mapStateToProps(state) {
    return {
      assets: assetsSelector(state),
      currentAsset: currentAssetSelector(state),
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      clearAssets: () => dispatch(clearAssets()),
      loadAssets: filter => dispatch(loadAssets(filter)),
      loadAsset: assetId => dispatch(loadAsset({ assetId })),
      setCurrentAsset: assetId => dispatch(setCurrentAsset(assetId)),
    };
  }

  return compose(
    setDisplayName('AssetSelectionStepContainer'),
    connect(mapStateToProps, mapDispatchToProps),
    immutableToJS,
  )(Container);
};

export default withConnectedData;



// WEBPACK FOOTER //
// ./compositions/AssetSelectionStep/Container.js